import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue-demi';

import AbTitle from '../AbTitle/AbTitle.vue';
import AbIcon from '../AbIcon/AbIcon.vue';
import type { Step } from './types';


export default /*#__PURE__*/_defineComponent({
  __name: 'AbStepper',
  props: {
    steps: null,
    currentStepIndex: null
  },
  emits: ["step-click"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'step-click', index: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  steps: Step[];
  currentStepIndex: number;
};





const onStepClick = (index: number) => {
  emit('step-click', index);
};

const currentStepSubtitle = computed(
  () => props.steps[props.currentStepIndex].subtitle || '',
);

return { __sfc: true,props, emit, onStepClick, currentStepSubtitle, AbTitle, AbIcon }
}

})